import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ValueHoverComponent } from './components/value-hover/value-hover.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ValueHoverComponent],
  exports: [ValueHoverComponent],
})
export class CoreUiValueHoverModule {}
